import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function

const ProductListOne = () => {
  const [products, setProducts] = useState([]);

  const WC_URL = process.env.REACT_APP_WC_URL;
  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;

 useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/allproducts/`
      );

      const data = await res.json();

      if (data.status) {
        
        setProducts(data.data);
      }
    } catch (err) {
      console.error("Product fetch error:", err);
    }
  };

  fetchProducts();
}, []);

  
//  const [wishlistItems, setWishlistItems] = useState([]);
// const [wishlistId, setWishlistId] = useState(null);

// useEffect(() => {
//   const fetchWishlist = async () => {
//     const token = localStorage.getItem("token");

    

//     if (!token) return;

//     try {
//       const res = await fetch(
//         "https://ecom.brightcodeapp.com/index.php/wp-json/yith/wishlist/v1/wishlists/get_by_user",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json"
//           },
//         }
//       );

//       const data = await res.json();

//       console.log("Wishlist response:", data);

//       if (data && data.id) {
//         setWishlistId(data.id);

//         const productIds = data.items.map(item => item.product_id);
//         setWishlistItems(productIds);
//       }

//     } catch (error) {
//       console.error("Wishlist error:", error);
//     }
//   };

//   fetchWishlist();
// }, []);




//   const toggleWishlist = async (productId) => {
   
//   const token = localStorage.getItem("jwt_token");
//   if (!token || !wishlistId) return;

//   const isInWishlist = wishlistItems.includes(productId);

//   if (isInWishlist) {
//     await fetch(
//       `https://ecom.brightcodeapp.com/wp-json/yith/wishlist/v1/wishlist/${wishlistId}/remove/${productId}`,
//       {
//         method: "DELETE",
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );

//     setWishlistItems(prev => prev.filter(id => id !== productId));
//   } else {
//     await fetch(
//       `https://ecom.brightcodeapp.com/wp-json/yith/wishlist/v1/wishlist/${wishlistId}/add`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ product_id: productId }),
//       }
//     );

//     setWishlistItems(prev => [...prev, productId]);
//   }
// };










  // 🎲 Shuffle + take 6 random products
  const randomSix = [...products]
    .sort(() => 0.5 - Math.random())
    .slice(0, 6);

  return (
    <div className="product mt-24">
      <div className="container container-lg">
        <div className="row gy-4 g-12">

          {randomSix.map((product) => (
            <div key={product.id} className="col-xxl-2 col-lg-3 col-sm-4 col-6">
              <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">

                {product.on_sale && (
                  <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                    Sale {Math.round(((product.regular_price - product.sale_price) / product.regular_price) * 100)}%
                  </span>
                )}

                {/* wishlist button */}
                {/* <button
                  onClick={() => toggleWishlist(product.id)}
                  className="wishlist-btn position-absolute top-0 end-0 m-10 bg-white rounded-circle shadow-sm flex-center"
                  style={{ width: "36px", height: "36px", zIndex: 2 }}
                >
                  <i
                    className={
                      wishlistItems.includes(product.id)
                        ? "ph-fill ph-heart text-danger"
                        : "ph ph-heart text-gray-500"
                    }
                  />
                </button> */}

                {/* Product Image */}
                <Link
                  to={`/product-details/${product.id}`}
                  className="product-card__thumb flex-center"
                >
                  <img
                    src={product.images?.[0]?.src || "assets/images/thumbs/placeholder.png"}
                    alt={product.name}
                  />
                </Link>


                <div className="product-card__content mt-12">

                  {/* Rating  */}
                  <div className="flex-align gap-6">
                    <span className="text-xs fw-bold text-gray-500">
                      {product.average_rating || "0.0"}
                    </span>
                    <span className="text-15 fw-bold text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-bold text-gray-500">
                      ({product.rating_count || 0})
                    </span>
                  </div>




                  {/* Title */}
                  <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link to={`/product-details/${product.id}`} className="link text-line-2">
                      {product.name}
                    </Link>

                  </h6>

                  {/* Store / Vendor */}
                  <div className="flex-align gap-4">
                    <span className="text-main-600 text-md d-flex">
                      <i className="ph-fill ph-storefront" />
                    </span>
                    <span className="text-gray-500 text-xs">
                      By {product.store?.name || "Store"}
                    </span>
                  </div>

                  {/* Price */}
                  <div className="flex-between gap-8 mt-24 flex-wrap">
                    <div className="product-card__price">
                      {product.regular_price && (
                        <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                          ₹{product.regular_price}
                        </span>
                      )}
                      <span className="text-heading text-md fw-semibold">
                        ₹{product.price}{" "}
                        <span className="text-gray-500 fw-normal">/Qty</span>
                      </span>
                    </div>

                    <button
                      onClick={() => handleAddToCart(product.id)}
                      className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
                    >
                      Add <i className="ph ph-shopping-cart" />
                    </button>

                  </div>

                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default ProductListOne;
